import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-card-testimonial',
  templateUrl: './card-testimonial.component.html',
  styleUrls: ['./card-testimonial.component.css']
})
export class CardTestimonialComponent implements OnInit {

  @Input() cardData;

  constructor() {
   }

  ngOnInit(): void {
    if(!this.cardData){
      this.cardData = {
        imageUrl: "'../../assets/voyjaleas/default.jpeg'",
      }
    }
  }
  
}
